import { useEffect, useRef } from 'react'

import { useAuth } from '@clerk/react'

import { setTokenProvider, TokenErrorReporter } from './index'

interface UseSessionTokenProps {
  /** Receives every failure to obtain a token from Clerk. */
  onTokenError?: TokenErrorReporter
}

/**
 * Registers Clerk's `getToken` as the app-wide source behind `getValidToken()`. Clerk owns
 * caching and refresh; callers ask for a token per request and never hold one.
 */
export const useSessionToken = ({ onTokenError }: UseSessionTokenProps = {}) => {
  const { getToken } = useAuth()

  const onTokenErrorRef = useRef(onTokenError)
  useEffect(() => {
    onTokenErrorRef.current = onTokenError
  })

  useEffect(() => {
    setTokenProvider(getToken, error => onTokenErrorRef.current?.(error))
    return () => setTokenProvider(null)
  }, [getToken])
}
